import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  Table,
  Paper,
  TableBody,
  TableCell,
  Tooltip,
  Box,
  TableContainer,
  TableHead,
  TableRow,
  InputAdornment,
  IconButton,
  Stack,
  Modal,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Chip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchIcon from '@mui/icons-material/Search';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useParams } from "react-router-dom";
import base64 from "base64-js";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SchoolIcon from "@mui/icons-material/School";
import EventSeatIcon from "@mui/icons-material/EventSeat";
import ChildCareIcon from "@mui/icons-material/ChildCare";


const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const Class = () => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 25, 50];
  const [canAdd, setCanAdd] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [classData, setClassData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedClassId, setSelectedClassId] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  let navigate = useNavigate();

  // Info dialog state
  const [infoOpen, setInfoOpen] = useState(false);

  const decodeFormId = (encodedFormId) => {
    if (!encodedFormId || typeof encodedFormId !== "string") {
      console.error("encodedFormId is missing or invalid:", encodedFormId);
      return null;
    }
    try {
      const paddedEncodedFormId = encodedFormId.padEnd(Math.ceil(encodedFormId.length / 4) * 4, "=");
      const bytes = base64.toByteArray(paddedEncodedFormId);
      return new TextDecoder().decode(bytes);
    } catch (error) {
      console.error("Error decoding formId:", error);
      return null;
    }
  };

  const { encodedFormId } = useParams();
  const formId = decodeFormId(encodedFormId);

  const Authorizer = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/CPanel/Module_Authorizer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ formId, }), // replace with actual formId if hardcoded
      });

      const result = await response.json();
      const data = result[0];

      // setAuthorization(data);
      setCanEdit(data?.uModify === 1);
      setCanAdd(data?.uWrite === 1);
      setCanDelete(data?.uDelete === 1);
    } catch (error) {
      console.error("Authorization check failed:", error);
    }
  };

  const handleClick = () => {
    navigate('/addclass');
  };

  const fetchClass = async () => {
    try {
      setIsLoading(true); // start loading
      const token = sessionStorage.getItem('token');
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${apiUrl}/CreateClass/GetClassName`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching financial years: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Sorry! No record found!") {
        throw new Error("Record Not Found");
      }
      setClassData(data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false); // stop loading
    }
  };


  useEffect(() => {
    fetchClass();
    Authorizer();
  }, []);


  const handleDelete = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const Url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${Url}/CreateClass/Id?Id=${selectedClassId}`;
      const response = await fetch(apiUrl, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });

      if (response.ok) {
        // If deletion is successful, refresh the class data
        fetchClass();
        handleCloseModal(true);
        setSnackbarMessage('Class deleted successfully!');
        setOpenSnackbar(true);
        setSnackbarSeverity("success")
      } else {
        console.error('Failed to delete class');
        // alert('Failed to delete class');
        setSnackbarMessage('Failed to delete class');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");

      }
    } catch (error) {
      console.error('API request error:', error);
      // alert('An error occurred. Please try again later.');
       setSnackbarMessage('An error occurred. Please try again later.');
        setOpenSnackbar(true);
        setSnackbarSeverity("error")
    }
  };

  const handleShowModal = (classId) => {
    setSelectedClassId(classId);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedClassId(null);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  const handleChangePage = (event, newPage) => {
  setPage(newPage);
};

const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(1); // reset to page 1
};

const filteredData = classData
                    .filter(row => row.className.toLowerCase().includes(searchQuery));
const paginatedData = filteredData.slice(
  (page - 1) * rowsPerPage,
  page * rowsPerPage
);

  return (
    <Container >
      {/* Header Box with Title + Info Button */}
      <Box
        sx={{
          backgroundColor: '#0B1F40', // dark navy blue
          padding: '12px 24px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '2px auto',
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Class Details
        </Typography>

        {/* ── Info Button ── */}
        <Tooltip title="About this page" arrow>
          <IconButton
            onClick={() => setInfoOpen(true)}
            size="small"
            sx={{
              color: "rgba(255,255,255,0.75)",
              border: "1.5px solid rgba(255,255,255,0.35)",
              borderRadius: "50%",
              width: 30,
              height: 30,
              ml: 0.5,
              transition: "all 0.2s ease",
              "&:hover": {
                color: "#ffffff",
                backgroundColor: "rgba(100,181,246,0.2)",
                borderColor: "#64B5F6",
                transform: "scale(1.1)",
                boxShadow: "0 0 8px rgba(100,181,246,0.4)",
              },
            }}
          >
            <InfoOutlinedIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      </Box>

      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>
        <Container style={{ marginBottom: 16, display: 'flex', justifyContent: "space-between", alignItems: 'center' }}>        <TextField
          variant="outlined"
          placeholder="Search by Class Name"
          value={searchQuery}
          onChange={handleSearchChange}
          style={{ width: "300px" }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}

        />
          <Tooltip title={!canAdd && "You are not Authorized to Add"} arrow><span></span>

            <Button
              variant="contained"
              color="primary"
              style={{
                width: "160px",
                height: "50px",
                padding: "10px 0",
                fontWeight: 'bold'
              }}
              disabled={!canAdd}
              onClick={handleClick}
            >
              ADD NEW CLASS
            </Button></Tooltip>
        </Container>

       
            <TableContainer component={Paper}>
              <Table
                sx={{
                  minWidth: 650,
                  border: '1px solid #ccc',
                  '& .MuiTableCell-root': {
                    borderRight: '1px solid #ccc',
                    fontSize: '1rem',
                  },
                  '& .MuiTableHead-root .MuiTableCell-root': {
                    fontWeight: 'bold',
                    backgroundColor: '#f5f5f5',
                  },
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                      S.NO
                    </TableCell>
                    <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                      Class
                    </TableCell>
                    <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                      Max Lecture
                    </TableCell>
                    <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                      Min Age
                    </TableCell>
                    <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                      Max Age
                    </TableCell>
                    <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem', textAlign: 'center' }}>
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
               <TableBody>
  {isLoading ? (
    <TableRow>
      <TableCell colSpan={6} align="center">
        <CircularProgress />
      </TableCell>
    </TableRow>
  ) : paginatedData.length > 0 ? (
    paginatedData.map((row, index) => (
      <TableRow key={index} sx={{ borderTop: '1px solid #ccc' }}>
        <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1.1rem' }}>{index + 1}</TableCell>
        <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1.1rem' }}>{row.className}</TableCell>
        <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1.1rem' }}>{row.maxLecture}</TableCell>
        <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1.1rem' }}>{row.minAge}</TableCell>
        <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1.1rem' }}>{row.maxAge}</TableCell>
        <TableCell sx={{ textAlign: 'center', borderRight: '1px solid #ccc', fontSize: '1.1rem' }}>
          <Tooltip title={!canEdit && "You are not Authorized to Edit"} arrow>
            <span>
              <Button
                variant="contained"
                color="warning"
                onClick={() => navigate(`/editclass/${row.classId}`)}
                className="mx-1"
                disabled={!canEdit}
              >
                Edit
              </Button>
            </span>
          </Tooltip>
          <Tooltip title={!canDelete && "You are not Authorized to Delete"} arrow>
            <span>
              <Button
                variant="contained"
                color="error"
                onClick={() => handleShowModal(row.classId)}
                className="mx-1"
                disabled={!canDelete}
              >
                Delete
              </Button>
            </span>
          </Tooltip>
        </TableCell>
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell colSpan={6} align="center">
        No Classes Found
      </TableCell>
    </TableRow>
  )}
</TableBody>

              </Table>
            </TableContainer>

         
          {filteredData.length > 0 && (
  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
    <TextField
      select
      label="Rows per page"
      value={rowsPerPage}
      onChange={handleChangeRowsPerPage}
      sx={{ width: 150 }}
      SelectProps={{
        native: true,
      }}
    >
      {rowsPerPageOptions.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </TextField>

    <Box>
      <Typography variant="body2" sx={{ display: 'inline-block', marginRight: 2 }}>
        Page {page} of {Math.ceil(filteredData.length / rowsPerPage)}
      </Typography>
      <Button
        variant="outlined"
        onClick={() => handleChangePage(null, page - 1)}
        disabled={page === 1}
        sx={{ mr: 1 }}
      >
        Prev
      </Button>
      <Button
        variant="outlined"
        onClick={() => handleChangePage(null, page + 1)}
        disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
      >
        Next
      </Button>
    </Box>
  </Box>
)}

      </Paper>

      {/* Confirmation Modal */}
      <Modal open={showModal} onClose={handleCloseModal} aria-labelledby="delete-modal-title" aria-describedby="delete-modal-description">
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Delete Confirmation ⚠️
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="delete-modal-description" sx={{ mb: 2 }}>
              Are you sure you want to delete this class?
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button onClick={handleCloseModal} variant="outlined" sx={{ mr: 1 }}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={handleDelete}
              >
                Yes, Delete
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* ── Info Dialog ── */}
      <Dialog
        open={infoOpen}
        onClose={() => setInfoOpen(false)}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "16px",
            boxShadow: "0 12px 40px rgba(11,31,61,0.2)",
            overflow: "hidden",
          },
        }}
      >
        {/* Header */}
        <DialogTitle
          sx={{
            background: "linear-gradient(135deg, #0B1F3D 0%, #1565C0 100%)",
            color: "#ffffff",
            fontWeight: 700,
            fontSize: "1.2rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            py: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <InfoOutlinedIcon sx={{ fontSize: 22 }} />
            Class Details — Page Guide
          </Box>
         
        </DialogTitle>

        <DialogContent sx={{ px: 3, py: 2.5 }}>

          {/* Purpose */}
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2, lineHeight: 1.7 }}>
            This page allows you to manage all class records in the system. You can view existing
            classes along with their lecture limits and age restrictions, and perform add, edit,
            or delete operations based on your assigned permissions.
          </Typography>

          <Divider sx={{ mb: 2 }} />

          {/* Features */}
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.2, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
            Features &amp; Controls
          </Typography>

          <List dense disablePadding>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <SearchIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Search by Class Name</Typography>}
                secondary="Type in the search box to instantly filter classes by name."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <AddCircleOutlineIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Add New Class</Typography>}
                secondary="Click 'ADD NEW CLASS' to open the class creation form. Requires Add permission."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <EditOutlinedIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Edit a Class</Typography>}
                secondary="Click the 'Edit' button on any row to modify that class's details. Requires Edit permission."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <DeleteOutlineIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Delete a Class</Typography>}
                secondary="Click 'Delete' on a row to open a confirmation dialog before permanently removing the class. Requires Delete permission."
              />
            </ListItem>

          </List>

          <Divider sx={{ my: 2 }} />

          {/* Column descriptions */}
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.2, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
            Table Column Reference
          </Typography>

          <List dense disablePadding>
            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <SchoolIcon sx={{ fontSize: 20, color: "#555" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Class</Typography>}
                secondary="The name of the class (e.g., Grade 1, Class 10, etc.)."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <EventSeatIcon sx={{ fontSize: 20, color: "#555" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Max Lecture</Typography>}
                secondary="The maximum number of lectures allowed per day for this class."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <ChildCareIcon sx={{ fontSize: 20, color: "#555" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Min Age / Max Age</Typography>}
                secondary="The eligible age range for students to be enrolled in this class."
              />
            </ListItem>
          </List>

          <Divider sx={{ my: 2 }} />

          {/* Permissions */}
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
            Your Permissions
          </Typography>
          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            <Chip
              label={`Add: ${canAdd ? "✔ Allowed" : "✘ Restricted"}`}
              size="small"
              sx={{ backgroundColor: canAdd ? "#e8f5e9" : "#fce4ec", color: canAdd ? "green" : "red", fontWeight: 600 }}
            />
            <Chip
              label={`Edit: ${canEdit ? "✔ Allowed" : "✘ Restricted"}`}
              size="small"
              sx={{ backgroundColor: canEdit ? "#e8f5e9" : "#fce4ec", color: canEdit ? "green" : "red", fontWeight: 600 }}
            />
            <Chip
              label={`Delete: ${canDelete ? "✔ Allowed" : "✘ Restricted"}`}
              size="small"
              sx={{ backgroundColor: canDelete ? "#e8f5e9" : "#fce4ec", color: canDelete ? "green" : "red", fontWeight: 600 }}
            />
          </Box>

        </DialogContent>

        <DialogActions sx={{ backgroundColor: "#f5f5f5", px: 3, py: 2 }}>
          <Button
            onClick={() => setInfoOpen(false)}
            variant="contained"
            sx={{
              backgroundColor: "#0B1F3D",
              color: "#fff",
              borderRadius: "8px",
              fontWeight: 600,
              "&:hover": { backgroundColor: "#1565C0" },
            }}
          >
            Got it
          </Button>
        </DialogActions>
      </Dialog>
      {/* ── End Info Dialog ── */}

    </Container>
  );
};

export default Class;